import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import ATSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATSField";
import ETCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETCField";
import ExternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ExternalNotesAndAttachments";
import InternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/InternalNotesAndAttachments";
import RejectionReasonAndAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/RejectionReasonAndAttachment";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";
import ActualQuantityField from "../extra-fields/ActualQuantityField";
import BillOfLadingAttachment from "../extra-fields/BillOfLadingAttachment";
import CargoType from "../extra-fields/CargoType";
import OperationType from "../extra-fields/OperationType";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}
const extraFieldsMap = {
  internalNotes: () => <InternalNotesAndAttachmentsComponent />,
  externalNotes: () => <ExternalNotesAndAttachmentsComponent />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  billOfLading: () => <BillOfLadingAttachment />,
  cargoType: () => <CargoType />,
  operationType: () => <OperationType />,
  actualQuantity: (props: ExtraFieldProps) => <ActualQuantityField {...props} />,
};

type ShipToShipExtraFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const ShipToShipExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: ShipToShipExtraFieldsProps) => {
  return (
    <div className="flex flex-col gap-2">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];

              if (!FieldComponent) return null;

              return (
                <div className="mt-4" key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default ShipToShipExtraFields;
